import { useQuery } from '@tanstack/react-query';
import { itemsApi } from '../api/items';

export function useItem(itemId: string) {
  return useQuery({
    queryKey: ['item', itemId],
    queryFn: () => itemsApi.getById(itemId),
    enabled: Boolean(itemId),
  });
}
